import * as React from 'react';
import { scrollToAnchor } from '@cian/newbuilding-utils';
import { PictogramProductEscrou40 } from '@cian/ui-kit-design-tokens/pictograms';
import { useSelector } from 'react-redux';

import { OffersReliableBlock, OffersReliableBlockLayout } from '../../components/OffersReliableBlock';
import {
  getIsReliableCurrentHouse,
  getHasProblemsCurrentHouse,
  getIsEscrowCurrentHouse,
} from '../../selectors/newbuilding';
import { getSelectedHouseId } from '../../selectors/offers';
import { trackOffersReliableLabelClick } from './tracking';
import { RightReliableBanner } from '../../components/RightReliableLabelRedesigned';
import { reliabilitySelector } from '../../selectors/reliability/reliabilitySelector';

export function OffersReliableBlockContainer() {
  const isReliable = useSelector(getIsReliableCurrentHouse);
  const hasProblems = useSelector(getHasProblemsCurrentHouse);
  const isEscrow = useSelector(getIsEscrowCurrentHouse);
  const houseId = useSelector(getSelectedHouseId);
  const reliability = useSelector(reliabilitySelector);

  if (!isReliable && !hasProblems && !isEscrow) {
    return null;
  }

  const escrowText = houseId ? 'Сделка с эскроу-счётом' : 'Есть корпуса со сделкой с эскроу–счётом';

  const onOffersReliableLabelClick = (anchor: string, label: string) => (event: React.MouseEvent<HTMLElement>) => {
    scrollToAnchor({
      anchor,
      offset: 0,
      hasRelocation: false,
      hasAnimation: true,
    })(event);
    trackOffersReliableLabelClick(label);
  };

  return (
    <OffersReliableBlockLayout>
      <RightReliableBanner
        reliability={reliability}
        onReliableClick={onOffersReliableLabelClick('#reliable', 'flats_reliable_dev')}
        onProblemClick={onOffersReliableLabelClick('#reliable', 'flats_problem_building')}
        isBoldTitle={false}
      />
      {isEscrow && (
        <OffersReliableBlock
          text={escrowText}
          icon={<PictogramProductEscrou40 color="icon-main-default" />}
          styleName={'container-escrow'}
          onClick={onOffersReliableLabelClick('#escrow', 'flats_escrow')}
        />
      )}
    </OffersReliableBlockLayout>
  );
}
